import { AgentCommon } from '~/agents/common/common/agent'

export const CustomerSupportAgentCommon: AgentCommon = {
  key: 'customerSupport',
  hasOnboarding: true,
  hasSettings: true,
  guidelines: [
    {
      label: 'When replying to customers',
      tag: 'support responses',
      suggestions: [
        'Always greet the customer by name',
        'Acknowledge their issue or concern',
        'Keep responses short and clear',
        'Use a polite and empathetic tone',
        'Avoid technical jargon unless necessary',
        'Restate the problem for clarity',
        'Provide step-by-step instructions',
        'Thank the user for their patience',
        'Avoid copy-paste style replies—personalize',
        'Apologize when appropriate, even if not at fault',
        'Include links to helpful resources when relevant',
        'Confirm resolution or next steps at the end',
        'Set expectations for response times',
        'Offer to follow up if needed',
        'Use friendly closings ("Let me know if I can help further!")',
        'Avoid ALL CAPS or excessive punctuation',
        'Be transparent if something is still being investigated',
        `Never make promises you can't keep`,
        'Double-check grammar and spelling before sending',
        'Be proactive—anticipate follow-up questions',
      ],
    },
    {
      label: 'When analysing new emails',
      tag: 'new emails',
      suggestions: [
        'Ignore auto-replies like "Out of Office"',
        'Ignore newsletters or marketing emails',
        'Skip any email that starts with "Thank you for your response"',
        'Focus only on emails sent to support@company.com',
        `Ignore forwarded threads unless there's a new question`,
        'Ignore emails containing only signatures or quoted replies',
        'Prioritize emails with keywords like "issue", "problem", "error"',
        'Ignore notifications from external services (e.g. GitHub, Stripe)',
        'Ignore internal company emails unless tagged as support',
        'Focus on emails from customers, not team members',
        'Ignore emails flagged as spam or marketing',
        'Ignore emails with no subject and empty body',
        'Ignore emails from noreply@ addresses',
        'Prioritize emails marked as urgent or high priority',
        'Ignore automated survey completions',
        `Ignore payment confirmations or invoices unless there's a question`,
        'Ignore social media notifications',
        'Skip emails with attachments only (unless described in text)',
        'Ignore bounced or failed delivery reports',
      ],
    },
  ],
}
